export enum BackgroundWorkStatus {
    Pending,
    Processing,
    Failed,
    Done
}
